const API_URL = 'https://apistalk.beautyskincare.dev/api/';
// const API_URL = 'http://localhost/php-app/api/';

function ratings(level) {
  const rate = {
    5: 'best',
    4: 'good',
    3: 'average',
    2: 'bad',
    1: 'worst',
    unknown: 'unknown',
  };

  return rate[level] ?? 'not rated';
}

function ratingsKeys(level) {
  const rate = {
    5: 'best',
    4: 'good',
    3: 'average',
    2: 'bad',
    1: 'worst',
    unknown: 'unknown',
  };

  return rate[level] ?? 'notrated';
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function redirectIfNotFound() {
  const destination_url = '/pages/ingredient-dictionary';
  window.location.href = destination_url;
}

function displayArrayIntext(arr, element, comma = true) {
  let content = '';
  const addcomma = comma ? ', ' : '';

  arr.forEach((item, index) => {
    if (arr.length === index + 1) {
      content += `<${element}>${item}</${element}>`;
    } else {
      content += `<${element}>${item}</${element}>${addcomma}`;
    }
  });

  return content;
}

function displayArrayLink(arr, element, link, comma = true) {
  let content = '';
  const addcomma = comma ? ', ' : '';

  arr.forEach((item, index) => {
    if (arr.length === index + 1) {
      content += `<${element} href="${link}${item}">${item}</${element}>`;
    } else {
      content += `<${element} href="${link}${item}">${item}</${element}>${addcomma}`;
    }
  });

  return content;
}

// sorting functions from A-Z and Z-A with numbers
function startsWithNumber(s) {
  return /^\d/.test(s);
}

// Custom sort function for A-Z where numbers come first
function sortByAZ(data) {
  return data.sort((a, b) => {
    const aStartsWithNumber = startsWithNumber(a.name);
    const bStartsWithNumber = startsWithNumber(b.name);

    if (aStartsWithNumber && !bStartsWithNumber) {
      return -1; // a comes first
    }
    if (!aStartsWithNumber && bStartsWithNumber) {
      return 1; // b comes first
    }
    return a.name.localeCompare(b.name); // Alphabetic comparison if both are same type
  });
}

function sortByZA(data) {
  return data.sort((a, b) => {
    const aStartsWithNumber = startsWithNumber(a.name);
    const bStartsWithNumber = startsWithNumber(b.name);

    if (aStartsWithNumber && !bStartsWithNumber) {
      return 1; // b comes first
    }
    if (!aStartsWithNumber && bStartsWithNumber) {
      return -1; // a comes first
    }
    return b.name.localeCompare(a.name); // Reverse alphabetic comparison if both are same type
  });
}

function sortByRating(data, order = 'asc') {
  return data.sort((a, b) => {
    const ratingA =
      a.rating === ''
        ? order === 'asc'
          ? Number.POSITIVE_INFINITY
          : Number.NEGATIVE_INFINITY
        : parseInt(a.rating);
    const ratingB =
      b.rating === ''
        ? order === 'asc'
          ? Number.POSITIVE_INFINITY
          : Number.NEGATIVE_INFINITY
        : parseInt(b.rating);

    return order === 'asc' ? ratingA - ratingB : ratingB - ratingA;
  });
}

// filter
function filterAlphabet(data) {
  const counts = {};

  for (let i = 1; i <= 9; i++) {
    counts[i.toString()] = 0;
  }
  for (let ch = 65; ch <= 90; ch++) {
    counts[String.fromCharCode(ch)] = 0;
  }

  data.forEach((item) => {
    const firstChar = item.name.trim()[0].toUpperCase();
    if (counts.hasOwnProperty(firstChar)) {
      counts[firstChar]++;
    }
  });

  return counts;
}

function filterRatings(data) {
  const counts = {};

  data.forEach((item) => {
    const { rating } = item;
    if (rating) {
      counts[rating] = (counts[rating] || 0) + 1; // Initialize or increment the count
    }
  });

  return counts;
}

function filterCategories(data) {
  const counts = {};

  data.forEach((item) => {
    const { categories } = item;
    if (categories && categories.length > 0) {
      categories.forEach((category) => {
        counts[category] = (counts[category] || 0) + 1;
      });
    }
  });

  return counts;
}

function filterBenefits(data) {
  const counts = {};

  data.forEach((item) => {
    const { benefits } = item;
    if (benefits && benefits.length > 0) {
      benefits.forEach((benefit) => {
        counts[benefit] = (counts[benefit] || 0) + 1;
      });
    }
  });

  return counts;
}

function formatText(text) {
  if (text === 'anti-aging' || text === 'anti-acne') {
    return text;
  }
  return text.replace(/-/g, ' ');
}

//render filter
function renderAlphabet(data, itemsToShow = Infinity) {
  const resultKeys = Object.keys(data);
  const parentElement = document.getElementsByClassName('alphabatically')[0];
  if (resultKeys.length === 0) {
    parentElement.innerHTML = '';
    return;
  }

  let str = '<p>Alphabetically</p>';

  let moreItems = resultKeys.length > itemsToShow;

  resultKeys.slice(0, itemsToShow).forEach((key) => {
    if (data[key] === 0) return;

    str += `<label for="${key}-alphabet"> <input type="checkbox" class="alpha filter_alphabet" id="${key}-alphabet" value="${key}">${key} (${data[key]}) </label>`;
  });

  if (moreItems) {
    str += `<div class="more-alphabet-label" style="display: none;">`;
    resultKeys.slice(itemsToShow).forEach((key) => {
      if (data[key] === 0) return;

      str += `<label for="${key}-alphabet"> <input type="checkbox" class="alpha filter_alphabet" id="${key}-alphabet" value="${key}">${key} (${data[key]}) </label>`;
    });
    str += `</div>`;
    str += `<button class="more-alphabet-btn more-btn" onclick="showMoreAlphabet()">More</button>`;
  }
  parentElement.innerHTML = str;
}

function showMoreAlphabet() {
  document
    .querySelectorAll('.more-alphabet-label')
    .forEach((label) => (label.style.display = 'inline'));
  document
    .querySelectorAll('.more-alphabet-btn')
    .forEach((button) => (button.style.display = 'none'));
}

function renderRatings(data) {
  const resultKeys = Object.keys(data);
  const parentElement = document.getElementsByClassName('rating')[0];
  if (resultKeys.length === 0) {
    parentElement.innerHTML = '';
    return;
  }

  let str = '<p>RATING</p>';
  resultKeys
    .sort((a, b) => b - a)
    .forEach((key) => {
      if (data[key] === 0) return;

      str += `<label for="${key}-ratings"> <input type="checkbox" class="alpha filter_ratings" id="${key}-ratings" value="${key}">${ratings(
        key
      )} (${data[key]}) </label>`;
    });
  parentElement.innerHTML = str;
}

function renderBenefits(data, itemsToShow = Infinity) {
  const resultKeys = Object.keys(data);
  const parentElement = document.getElementsByClassName('benefits')[0];
  if (resultKeys.length === 0) {
    parentElement.innerHTML = '';
    return;
  }

  let str = '<p>BENEFIT</p>';
  let moreItems = resultKeys.length > itemsToShow;

  resultKeys
    .sort((a, b) => b - a)
    .slice(0, itemsToShow)
    .forEach((key) => {
      if (data[key] === 0) return;

      str += `<label for="${key}-benefits"> <input type="checkbox" class="alpha filter_benefits" id="${key}-benefits" value="${key}">${formatText(
        key
      )} (${data[key]})</label>`;
    });

  if (moreItems) {
    str += `<div class="more-benefits-label" style="display: none;">`;
    resultKeys
      .sort((a, b) => b - a)
      .slice(itemsToShow)
      .forEach((key) => {
        if (data[key] === 0) return;

        str += `<label for="${key}-benefits"> <input type="checkbox" class="alpha filter_benefits" id="${key}-benefits" value="${key}">${formatText(
          key
        )} (${data[key]}) </label>`;
      });
    str += `</div>`;
    str += `<button class="more-benefits-btn more-btn" onclick="showMoreBenefits()">More</button>`;
  }

  parentElement.innerHTML = str;
}

function showMoreBenefits() {
  document
    .querySelectorAll('.more-benefits-label')
    .forEach((label) => (label.style.display = 'inline'));
  document
    .querySelectorAll('.more-benefits-btn')
    .forEach((button) => (button.style.display = 'none'));
}

function renderCategories(data, itemsToShow = Infinity) {
  const resultKeys = Object.keys(data);
  const parentElement = document.getElementsByClassName('categories')[0];
  if (resultKeys.length === 0) {
    parentElement.innerHTML = '';
    return;
  }

  let str = '<p>CATEGORY</p>';
  let moreItems = resultKeys.length > itemsToShow;

  resultKeys
    .sort((a, b) => b - a)
    .slice(0, itemsToShow)
    .forEach((key) => {
      if (data[key] === 0) return;

      str += `<label for="${key}-categories"> <input type="checkbox" class="alpha filter_categories" id="${key}-categories" value="${key}">${formatText(
        key
      )} (${data[key]}) </label>`;
    });

  if (moreItems) {
    str += `<div class="more-categories-label" style="display: none;">`;
    resultKeys
      .sort((a, b) => b - a)
      .slice(itemsToShow)
      .forEach((key) => {
        if (data[key] === 0) return;

        str += `<label for="${key}-categories"> <input type="checkbox" class="alpha filter_categories" id="${key}-categories" value="${key}">${formatText(
          key
        )} (${data[key]}) </label>`;
      });
    str += `</div>`;
    str += `<button class="more-categories-btn more-btn" onclick="showMoreCategories()">More</button>`;
  }

  parentElement.innerHTML = str;
}

function showMoreCategories() {
  document
    .querySelectorAll('.more-categories-label')
    .forEach((label) => (label.style.display = 'inline'));
  document
    .querySelectorAll('.more-categories-btn')
    .forEach((button) => (button.style.display = 'none'));
}

function groupByRanking(entries, sort = 'best') {
  let rankings = [
    { key: '5', values: [] },
    { key: '4', values: [] },
    { key: '3', values: [] },
    { key: '2', values: [] },
    { key: '1', values: [] },
    { key: 'not_rated', values: [] },
    { key: 'unknown', values: [] },
  ];

  if (sort === 'worst') {
    rankings = [
      { key: '1', values: [] },
      { key: '2', values: [] },
      { key: '3', values: [] },
      { key: '4', values: [] },
      { key: '5', values: [] },
      { key: 'not_rated', values: [] },
      { key: 'unknown', values: [] },
    ];
  }

  function findCategory(key) {
    return rankings.find((category) => category.key === key);
  }

  entries.forEach((entry) => {
    if (entry.matchStatus === 'NO_MATCH') {
      findCategory('unknown').values.push(entry);
    } else if (entry.details.rating === '') {
      findCategory('not_rated').values.push(entry);
    } else {
      const category = findCategory(entry.details.rating);
      if (category) {
        category.values.push(entry);
      }
    }
  });

  return rankings;
}

function groupByBenefits(entries) {
  let benefitsGroup = {};

  entries.forEach((entry) => {
    if (
      entry.matchStatus === 'NO_MATCH' ||
      entry.details.benefits.length === 0
    ) {
      return;
    }

    entry.details.benefits.forEach((benefit) => {
      if (!benefitsGroup[benefit]) {
        benefitsGroup[benefit] = [];
      }
      benefitsGroup[benefit].push(entry);
    });
  });

  return benefitsGroup;
}

function groupByFunctions(entries) {
  let functionGroup = {}; // categories

  entries.forEach((entry) => {
    if (
      entry.matchStatus === 'NO_MATCH' ||
      entry.details.categories.length === 0
    ) {
      return;
    }

    entry.details.categories.forEach((category) => {
      if (!functionGroup[category]) {
        functionGroup[category] = [];
      }
      functionGroup[category].push(entry);
    });
  });

  return functionGroup;
}

let SGDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
